import { StoreEntityResult } from "../models/services/StoreEntityResult";
import { genericError } from "../models/GenericError";
import { BAD_REQUEST, CREATED, NO_CONTENT, OK, MINIMUM_STATUS_CODE, MAXIMUM_STATUS_CODE } from "../constants/response-status-codes";

export const validatePostAndPatchResponse = (response: Response, recordId: number ) => {
    return new Promise<StoreEntityResult>(async (resolve, reject) => {
        const responsesWithContent = [OK, CREATED, BAD_REQUEST];

        if (response) {
            if (response.status === NO_CONTENT) {
                return resolve({ id: recordId, success: true })
            }
            else if (responsesWithContent.includes(response.status)) {
                const content = await response.json();
                if (content.errors) {
                    return reject({ message: content.errors[0].detail, success: false });
                }
                return resolve({ id: content.data.id, success: true });
            }
            else {
                return reject({ success: false, message: genericError });
            }
        }
        else {
            return reject({ success: false, message: genericError });
        }
    });
}

/*
  An allowed status code falls between 199 and 300.
  This would include status of OK, No Content, Created, etc.
*/
export const isSuccessStatus = (statusCode: number) => {
    if (statusCode > MINIMUM_STATUS_CODE && statusCode < MAXIMUM_STATUS_CODE) {
        return true;
    }

    return false;
}